#import "../fragments/groupFragment.graphql"

mutation moveGroupRealTime($input: MoveGroupInput!) {
  result: moveGroupRealTime(input: $input) {
    validationError
    directGroups {
      ...GroupFragment
    }
  }
}

# Org chart DnD: success/error only; team data comes from getTeamAndMembersAndChildTeamsQuery.
mutation moveGroupOrgChart($input: MoveGroupInput!) {
  result: moveGroupRealTime(input: $input) {
    validationError
  }
}

mutation updateGroupName($groupId: ID!, $name: String!) {
  result: updateGroupName(groupId: $groupId, name: $name) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation createTeam($parentId: String!, $name: String!, $type: String!) {
  team: createTeam(parentId: $parentId, name: $name, type: $type) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation updateGroupType($groupId: ID!, $type: String!) {
  result: updateGroupType(groupId: $groupId, type: $type) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation updateGroupTypeRestricted($groupId: ID!, $type: String!) {
  result: updateGroupTypeRestricted(groupId: $groupId, type: $type) {
    id
    name
    type
    hierarchyIds
    hierarchy
  }
}

mutation updateGroups($groups: [GroupUpdateInput!]) {
  result: updateGroups(groups: $groups) {
    upsertSucceeded
    groupsSkipped
    validationErrors {
      message
    }
  }
}

mutation updateGroupDailyRate($groupId: ID!, $dailyRate: Float!) {
  result: updateGroupDailyRate(groupId: $groupId, dailyRate: $dailyRate) {
    id
    dailyRate
  }
}
